// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid transparent;
  outline: none;
  transition: all 0.2s ease-in-out;
  position: relative;
  white-space: nowrap;
}
.ui-button[data-tooltip]:not([data-tooltip=""]) {
  --tooltip-bg-color: #000;
  --tooltip-text-color: #fff;
}
.ui-button[data-tooltip]:not([data-tooltip=""]):after {
  visibility: hidden;
  content: attr(data-tooltip);
  position: absolute;
  border-style: solid;
  border-color: transparent transparent var(--tooltip-bg-color) transparent;
  min-width: 100%;
  background-color: var(--tooltip-bg-color);
  color: var(--tooltip-text-color);
  text-align: center;
  font-family: var(--primary-font);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  padding: 6px 8px;
  border-radius: 6px;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  max-height: 0;
  opacity: 0.9;
  z-index: 15;
  white-space: nowrap;
  display: none;
  justify-content: center;
  align-items: center;
  max-width: 400px;
  width: auto;
}
.ui-button[data-tooltip]:not([data-tooltip=""]):before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  visibility: hidden;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--tooltip-bg-color) transparent;
  z-index: 16;
}
.ui-button[data-tooltip]:not([data-tooltip=""])[data-tooltip-color=primary] {
  --tooltip-bg-color: var(--primary-color-500);
}
.ui-button[data-tooltip]:not([data-tooltip=""])[data-tooltip-color=secondary] {
  --tooltip-bg-color: var(--secondary-color-500);
}
.ui-button[data-tooltip]:not([data-tooltip=""])[data-tooltip-color=success] {
  --tooltip-bg-color: var(--alert-color-2);
}
.ui-button[data-tooltip]:not([data-tooltip=""])[data-tooltip-color=danger] {
  --tooltip-bg-color: var(--danger-color-500);
}
.ui-button[data-tooltip]:not([data-tooltip=""])[data-tooltip-color=warning] {
  --tooltip-bg-color: var(--alert-color-3);
}
.ui-button[data-tooltip]:not([data-tooltip=""])[data-tooltip-color=dark] {
  --tooltip-bg-color: var(--primary-color-dark-900);
}
.ui-button[data-tooltip]:not([data-tooltip=""]):hover:after, .ui-button[data-tooltip]:not([data-tooltip=""]):hover:before {
  visibility: visible;
  max-height: auto;
  display: inline-flex;
}
.ui-button:hover, .ui-button:focus {
  border-color: transparent;
}
.ui-button:focus-visible {
  outline: 2px solid var(--accent-color-1);
  outline-offset: 2px;
}
.ui-button--small {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  min-height: 32px;
}
.ui-button--small.ui-button--circle {
  width: 32px;
  height: 32px;
  padding: 0;
}
.ui-button--medium {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  min-height: 40px;
}
.ui-button--medium.ui-button--circle {
  width: 40px;
  height: 40px;
  padding: 0;
}
.ui-button--large {
  padding: 0.75rem 1.5rem;
  font-size: 1.125rem;
  min-height: 48px;
}
.ui-button--large.ui-button--circle {
  width: 48px;
  height: 48px;
  padding: 0;
}
.ui-button--rounded {
  border-radius: 0.5rem;
}
.ui-button--circle {
  border-radius: 50%;
  aspect-ratio: 1;
}
.ui-button--square {
  border-radius: 0.25rem;
}
.ui-button--primary {
  --ui-button-background: var(--primary-color-500);
  --ui-button-foreground: var(--primary-color-light-500);
  background-color: var(--ui-button-background);
  color: var(--ui-button-foreground);
  border-color: var(--ui-button-background);
}
.ui-button--primary:hover:not(:disabled), .ui-button--primary:disabled:hover {
  background-color: var(--ui-button-foreground);
  color: var(--ui-button-background);
  border-color: var(--ui-button-background);
}
.ui-button--primary:active:not(:disabled) {
  background-color: var(--ui-button-background);
}
.ui-button--primary:focus {
  background-color: var(--accent-color-1);
  color: var(--primary-color-light-500);
  border-color: var(--ui-button-background);
}
.ui-button--secondary {
  --ui-button-background: var(--secondary-color-500);
  --ui-button-foreground: var(--primary-color-light-500);
  background-color: var(--ui-button-background);
  color: var(--ui-button-foreground);
  border-color: var(--ui-button-background);
}
.ui-button--secondary:hover:not(:disabled), .ui-button--secondary:disabled:hover {
  background-color: var(--ui-button-foreground);
  color: var(--ui-button-background);
  border-color: var(--ui-button-background);
}
.ui-button--secondary:active:not(:disabled) {
  background-color: var(--ui-button-background);
}
.ui-button--secondary:focus {
  background-color: var(--secondary-color-500);
  color: var(--primary-color-light-500);
  border-color: var(--ui-button-background);
}
.ui-button--tertiary {
  background-color: transparent;
  color: var(--accent-color-1);
  border-color: var(--accent-color-1);
}
.ui-button--tertiary:hover:not(:disabled), .ui-button--tertiary:disabled:hover {
  background-color: var(--accent-color-1);
  color: var(--primary-color-light-500);
  border-color: var(--accent-color-1);
}
.ui-button--tertiary:active:not(:disabled) {
  background-color: var(--primary-color-light-opacity-45);
}
.ui-button--tertiary:focus {
  background-color: transparent;
  color: var(--accent-color-1);
  border-color: var(--accent-color-1);
}
.ui-button--danger {
  --ui-button-background: var(--danger-color-500);
  --ui-button-foreground: var(--primary-color-light-500);
  background-color: var(--ui-button-background);
  color: var(--ui-button-foreground);
  border-color: var(--ui-button-background);
}
.ui-button--danger:hover:not(:disabled), .ui-button--danger:disabled:hover {
  background-color: var(--ui-button-foreground);
  color: var(--ui-button-background);
  border-color: var(--ui-button-background);
}
.ui-button--danger:active:not(:disabled) {
  background-color: var(--alert-color-1);
}
.ui-button--danger:focus {
  background-color: var(--danger-color-500);
  color: var(--primary-color-light-500);
  border-color: var(--ui-button-background);
}
.ui-button--success {
  --ui-button-background: var(--alert-color-2);
  --ui-button-foreground: var(--primary-color-light-500);
  background-color: var(--ui-button-background);
  color: var(--ui-button-foreground);
  border-color: var(--ui-button-background);
}
.ui-button--success:hover:not(:disabled), .ui-button--success:disabled:hover {
  background-color: var(--ui-button-foreground);
  color: var(--ui-button-background);
  border-color: var(--ui-button-background);
}
.ui-button--success:active:not(:disabled) {
  background-color: var(--secondary-color-300);
}
.ui-button--success:focus {
  background-color: var(--alert-color-2);
  color: var(--primary-color-light-500);
  border-color: var(--ui-button-background);
}
.ui-button--full-width {
  width: 100%;
}
.ui-button--loading {
  cursor: wait;
  opacity: 0.7;
}
.ui-button--disabled, .ui-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: auto;
}
.ui-button__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ui-button__icon--right {
  margin-left: -0.25rem;
}
.ui-button__icon-svg {
  display: block;
}
.ui-button__loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ui-button__text {
  display: inline-block;
}
.ui-button--circle .ui-button__text:empty {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/form/Button/Button.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACE;EACE,wBAAA;EACA,0BAAA;AACJ;AACI;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;EAEA,mBAAA;EACA,yEAAA;EACA,eAAA;EACA,yCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAAN;AAGI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yEAAA;EACA,WAAA;AADN;AAKI;EACE,4CAAA;AAHN;AAMI;EACE,8CAAA;AAJN;AAOI;EACE,wCAAA;AALN;AAQI;EACE,2CAAA;AANN;AASI;EACE,wCAAA;AAPN;AAUI;EACE,iDAAA;AARN;AAYM;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;AAVR;AAgBE;EAEE,yBAAA;AAfJ;AAkBE;EACE,wCAAA;EACA,mBAAA;AAhBJ;AAoBE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;AAlBJ;AAoBI;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAlBN;AAsBE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;AApBJ;AAsBI;EACE,WAAA;EACA,YAAA;EACA,UAAA;AApBN;AAwBE;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AAtBJ;AAwBI;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAtBN;AA2BE;EACE,qBAAA;AAzBJ;AA4BE;EACE,kBAAA;EACA,eAAA;AA1BJ;AA6BE;EACE,sBAAA;AA3BJ;AA+BE;EACE,gDAAA;EACA,sDAAA;EACA,6CAAA;EACA,kCAAA;EACA,yCAAA;AA7BJ;AA+BI;EAEE,6CAAA;EACA,kCAAA;EACA,yCAAA;AA9BN;AAiCI;EACE,6CAAA;AA/BN;AAkCI;EACE,uCAAA;EACA,qCAAA;EACA,yCAAA;AAhCN;AAoCE;EACE,kDAAA;EACA,sDAAA;EACA,6CAAA;EACA,kCAAA;EACA,yCAAA;AAlCJ;AAoCI;EAEE,6CAAA;EACA,kCAAA;EACA,yCAAA;AAnCN;AAsCI;EACE,6CAAA;AApCN;AAuCI;EACE,4CAAA;EACA,qCAAA;EACA,yCAAA;AArCN;AAyCE;EACE,6BAAA;EACA,4BAAA;EACA,mCAAA;AAvCJ;AAyCI;EAEE,uCAAA;EACA,qCAAA;EACA,mCAAA;AAxCN;AA2CI;EACE,uDAAA;AAzCN;AA4CI;EACE,6BAAA;EACA,4BAAA;EACA,mCAAA;AA1CN;AA8CE;EACE,+CAAA;EACA,sDAAA;EACA,6CAAA;EACA,kCAAA;EACA,yCAAA;AA5CJ;AA8CI;EAEE,6CAAA;EACA,kCAAA;EACA,yCAAA;AA7CN;AAgDI;EACE,sCAAA;AA9CN;AAiDI;EACE,yCAAA;EACA,qCAAA;EACA,yCAAA;AA/CN;AAmDE;EACE,4CAAA;EACA,sDAAA;EACA,6CAAA;EACA,kCAAA;EACA,yCAAA;AAjDJ;AAmDI;EAEE,6CAAA;EACA,kCAAA;EACA,yCAAA;AAlDN;AAqDI;EACE,4CAAA;AAnDN;AAsDI;EACE,sCAAA;EACA,qCAAA;EACA,yCAAA;AApDN;AAyDE;EACE,WAAA;AAvDJ;AA0DE;EACE,YAAA;EACA,YAAA;AAxDJ;AA2DE;EAEE,mBAAA;EACA,YAAA;EACA,oBAAA;AA1DJ;AA8DE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AA5DJ;AAkEI;EACE,qBAAA;AAhEN;AAmEI;EACE,cAAA;AAjEN;AAsEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AApEJ;AAwEE;EACE,qBAAA;AAtEJ;AA0EE;EACE,aAAA;AAxEJ","sourcesContent":[".ui-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.5;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  border: 1px solid transparent;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  position: relative;\n  white-space: nowrap;\n\n  &[data-tooltip]:not([data-tooltip=\"\"])  {\n    --tooltip-bg-color: #000;\n    --tooltip-text-color: #fff;\n\n    &:after {\n      visibility: hidden;\n      content: attr(data-tooltip);\n      position: absolute;\n      \n      border-style: solid;\n      border-color: transparent transparent var(--tooltip-bg-color) transparent;\n      min-width: 100%;\n      background-color: var(--tooltip-bg-color);\n      color: var(--tooltip-text-color);\n      text-align: center;\n      font-family: var(--primary-font);\n      font-size: 0.875rem;\n      font-weight: 500;\n      line-height: 1.4;\n      padding: 6px 8px;\n      border-radius: 6px;\n      top: calc(100% + 10px);\n      left: 50%;\n      transform: translateX(-50%);\n      max-height: 0;\n      opacity: .9;\n      z-index: 15;\n      white-space: nowrap;\n      display: none;\n      justify-content: center;\n      align-items: center;\n      max-width: 400px;\n      width: auto;\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      visibility: hidden;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent var(--tooltip-bg-color) transparent;\n      z-index: 16;\n    }\n\n    // Color variants using data-tooltip-color attribute\n    &[data-tooltip-color=\"primary\"] {\n      --tooltip-bg-color: var(--primary-color-500);\n    }\n\n    &[data-tooltip-color=\"secondary\"] {\n      --tooltip-bg-color: var(--secondary-color-500);\n    }\n\n    &[data-tooltip-color=\"success\"] {\n      --tooltip-bg-color: var(--alert-color-2);\n    }\n\n    &[data-tooltip-color=\"danger\"] {\n      --tooltip-bg-color: var(--danger-color-500);\n    }\n\n    &[data-tooltip-color=\"warning\"] {\n      --tooltip-bg-color: var(--alert-color-3);\n    }\n\n    &[data-tooltip-color=\"dark\"] {\n      --tooltip-bg-color: var(--primary-color-dark-900);\n    }\n\n    &:hover {\n      &:after, &:before {\n        visibility: visible;\n        max-height: auto;\n        display: inline-flex;\n      }\n    }\n  }\n\n  // Block library styles that interfere with our button\n  &:hover,\n  &:focus {\n    border-color: transparent;\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--accent-color-1);\n    outline-offset: 2px;\n  }\n\n  // Sizes\n  &--small {\n    padding: 0.375rem 0.75rem;\n    font-size: 0.875rem;\n    min-height: 32px;\n\n    &.ui-button--circle {\n      width: 32px;\n      height: 32px;\n      padding: 0;\n    }\n  }\n\n  &--medium {\n    padding: 0.5rem 1rem;\n    font-size: 1rem;\n    min-height: 40px;\n\n    &.ui-button--circle {\n      width: 40px;\n      height: 40px;\n      padding: 0;\n    }\n  }\n\n  &--large {\n    padding: 0.75rem 1.5rem;\n    font-size: 1.125rem;\n    min-height: 48px;\n\n    &.ui-button--circle {\n      width: 48px;\n      height: 48px;\n      padding: 0;\n    }\n  }\n\n  // Shapes\n  &--rounded {\n    border-radius: 0.5rem;\n  }\n\n  &--circle {\n    border-radius: 50%;\n    aspect-ratio: 1;\n  }\n\n  &--square {\n    border-radius: 0.25rem;\n  }\n\n  // Variants\n  &--primary {\n    --ui-button-background: var(--primary-color-500);\n    --ui-button-foreground: var(--primary-color-light-500);\n    background-color: var(--ui-button-background);\n    color: var(--ui-button-foreground);\n    border-color: var(--ui-button-background);\n\n    &:hover:not(:disabled),\n    &:disabled:hover {\n      background-color: var(--ui-button-foreground);\n      color: var(--ui-button-background);\n      border-color: var(--ui-button-background);\n    }\n\n    &:active:not(:disabled) {\n      background-color: var(--ui-button-background);\n    }\n\n    &:focus {\n      background-color: var(--accent-color-1);\n      color: var(--primary-color-light-500);\n      border-color: var(--ui-button-background);\n    }\n  }\n\n  &--secondary {\n    --ui-button-background: var(--secondary-color-500);\n    --ui-button-foreground: var(--primary-color-light-500);\n    background-color: var(--ui-button-background);\n    color: var(--ui-button-foreground);\n    border-color: var(--ui-button-background);\n\n    &:hover:not(:disabled),\n    &:disabled:hover {\n      background-color: var(--ui-button-foreground);\n      color: var(--ui-button-background);\n      border-color: var(--ui-button-background);\n    }\n\n    &:active:not(:disabled) {\n      background-color: var(--ui-button-background);\n    }\n\n    &:focus {\n      background-color: var(--secondary-color-500);\n      color: var(--primary-color-light-500);\n      border-color: var(--ui-button-background);\n    }\n  }\n\n  &--tertiary {\n    background-color: transparent;\n    color: var(--accent-color-1);\n    border-color: var(--accent-color-1);\n\n    &:hover:not(:disabled),\n    &:disabled:hover {\n      background-color: var(--accent-color-1);\n      color: var(--primary-color-light-500);\n      border-color: var(--accent-color-1);\n    }\n\n    &:active:not(:disabled) {\n      background-color: var(--primary-color-light-opacity-45);\n    }\n\n    &:focus {\n      background-color: transparent;\n      color: var(--accent-color-1);\n      border-color: var(--accent-color-1);\n    }\n  }\n\n  &--danger {\n    --ui-button-background: var(--danger-color-500);\n    --ui-button-foreground: var(--primary-color-light-500);\n    background-color: var(--ui-button-background);\n    color: var(--ui-button-foreground);\n    border-color: var(--ui-button-background);\n\n    &:hover:not(:disabled),\n    &:disabled:hover {\n      background-color: var(--ui-button-foreground);\n      color: var(--ui-button-background);\n      border-color: var(--ui-button-background);\n    }\n\n    &:active:not(:disabled) {\n      background-color: var(--alert-color-1);\n    }\n\n    &:focus {\n      background-color: var(--danger-color-500);\n      color: var(--primary-color-light-500);\n      border-color: var(--ui-button-background);\n    }\n  }\n\n  &--success {\n    --ui-button-background: var(--alert-color-2);\n    --ui-button-foreground: var(--primary-color-light-500);\n    background-color: var(--ui-button-background);\n    color: var(--ui-button-foreground);\n    border-color: var(--ui-button-background);\n\n    &:hover:not(:disabled),\n    &:disabled:hover {\n      background-color: var(--ui-button-foreground);\n      color: var(--ui-button-background);\n      border-color: var(--ui-button-background);\n    }\n\n    &:active:not(:disabled) {\n      background-color: var(--secondary-color-300);\n    }\n\n    &:focus {\n      background-color: var(--alert-color-2);\n      color: var(--primary-color-light-500);\n      border-color: var(--ui-button-background);\n    }\n  }\n\n  // States\n  &--full-width {\n    width: 100%;\n  }\n\n  &--loading {\n    cursor: wait;\n    opacity: 0.7;\n  }\n\n  &--disabled,\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n    pointer-events: auto;\n  }\n\n  // Icon\n  &__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    &--left {\n\n    }\n\n    &--right {\n      margin-left: -0.25rem;\n    }\n\n    &-svg {\n      display: block;\n    }\n  }\n\n  // Loader\n  &__loader {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  // Text\n  &__text {\n    display: inline-block;\n  }\n\n  // Circle button with no text\n  &--circle &__text:empty {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
